import React, { createContext, useState } from 'react';
import User from 'src/models/user';

type UserSessionContext = {
  user: User;
  setUser: (user: User) => void;
  onDesignMockupPage: boolean;
  setOnDesignMockupPage: (onDesignMockupPage: boolean) => void;
};

interface UserSessionProviderProps {
  children?: React.ReactNode;
}
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserSessionContext = createContext<UserSessionContext>(
  {} as UserSessionContext,
);

const LOCAL_STORAGE_KEY_USER = 'user';
const LOCAL_STORAGE_KEY_ON_DESIGN_MOCKUP_PAGE = 'onDesignMockupPage';

export const UserSessionProvider: React.FC<UserSessionProviderProps> = ({
  children,
}) => {
  const [user, setUserState] = useState<User>(() => {
    // *have to store in local storage so as to not lose the value on reload or page navigation
    const currentUser = localStorage.getItem(LOCAL_STORAGE_KEY_USER);
    if (typeof currentUser === 'string' && typeof currentUser !== 'undefined') {
      try {
        return JSON.parse(currentUser);
      } catch (error) {
        console.log(
          `There is a problem with the ${LOCAL_STORAGE_KEY_USER} localStorage key`,
        );
      }
    } else {
      return {};
    }
  });

  const [onDesignMockupPage, setOnDesignMockupPageState] = useState<boolean>(
    () => {
      // have to store in local storage so as to not lose the value on reload or page navigation
      const currentOnDesignMockupPage = localStorage.getItem(
        LOCAL_STORAGE_KEY_ON_DESIGN_MOCKUP_PAGE,
      );
      if (
        typeof currentOnDesignMockupPage === 'string' &&
        typeof currentOnDesignMockupPage !== 'undefined'
      ) {
        try {
          return JSON.parse(currentOnDesignMockupPage);
        } catch (error) {
          console.log(
            `There is a problem with the ${LOCAL_STORAGE_KEY_USER} localStorage key`,
          );
        }
      } else {
        return false;
      }
    },
  );

  const setOnDesignMockupPage = (isOnPage: boolean) => {
    localStorage.setItem(
      LOCAL_STORAGE_KEY_ON_DESIGN_MOCKUP_PAGE,
      JSON.stringify(isOnPage),
    );
    setOnDesignMockupPageState(isOnPage);
  };

  const setUser = (userData: User) => {
    localStorage.setItem(LOCAL_STORAGE_KEY_USER, JSON.stringify(userData));
    setUserState(userData);
  };

  return (
    <UserSessionContext.Provider
      value={{
        user,
        setUser,
        onDesignMockupPage,
        setOnDesignMockupPage,
      }}
    >
      {children}
    </UserSessionContext.Provider>
  );
};
